import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../components/breadCrumb";
import CheckBox from "../components/common/CheckBox";
import ComboBoxData from "../components/common/ComboBoxData";
import ComboBoxDataMulti from "../components/common/ComboBoxDataMulti";
import { NumericBox } from "../components/common/NumericBox";
import PageContent from "../components/pageContent";
import ProductBreadCrumb from "../components/products/ProductBreadCrumb";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { apiGetAllBasesByProduct } from "../services/BasesService";
import { apiGetAllColorsForSampleCard } from "../services/ColorsService";
import { apiGetAllProducts } from "../services/ProductsService";
import { apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { MultiSelect } from "react-multi-select-component";

import './ExportRecepturPage.css';
import { apiGetAllSellers } from "../services/SellersService";
import { apiImportPriceUploadFileWithPrices } from "../services/ImportPricesService";
import { apiImportReceipts, apiImportReceiptsStatus } from "../services/ImportReceiptsService";
import Spinner from "../components/common/Spinner";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface Props {
    contextLevel: string;

}

const ImportRecepturPage = (props: Props) => {

    var currentdate = new Date();
    const { t } = useTranslation(undefined, { keyPrefix: 'ImportReceipts' });
    const [file, setFile] = useState<Blob>();
    const [fileName, setFileName] = useState<string>();
    const initJobData: any = {};
    const [jobData, setJobData] = useState({ data: initJobData, done: false, checkingEnabled: true });
    const [inProgress, setInProgress] = useState(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobIdentifierFromUrl = params.get('jobIdentifier') || '';

    useEffect(() => {
    
        const params = new URLSearchParams(location.search);
        const jobIdentifierFromUrl = params.get('jobIdentifier') || '';

        if (jobIdentifierFromUrl.length <= 0) {

            var jobId = "job_" + currentdate.getDate() + "_"
                + (currentdate.getMonth() + 1) + "_"
                + currentdate.getFullYear() + "_"
                + currentdate.getHours() + "_"
                + currentdate.getMinutes() + "_"
                + currentdate.getSeconds();

            window.location.href = `${window.location.href}?jobIdentifier=${jobId}`;
        }
        else {
            checkStatus();
        }

    }, [])


    const checkStatus = async () => {

        let response = await apiImportReceiptsStatus(jobIdentifierFromUrl, 0);

        if (response.status == 200) {

            if (response.data.status == '---') {
                setJobData({ ...jobData, data: response.data, done: true });
                setInProgress(false);
                return;
            }
        }
    }

    useEffect(() => {

        if (inProgress) {
            checkingStatusCheckInterval();
        }

    }, [inProgress]);

    const checkingStatusCheckInterval = async () => {


        while (true) {

            let response = await apiImportReceiptsStatus(jobIdentifierFromUrl, 5000);

            if (response.status == 200) {

                setJobData({ ...jobData, data: response.data });

                if (response.data.status == '---') {
                    setInProgress(false);
                    window.location.reload();
                    return;
                }
            }

        }


    }


    const handleFileChange = (e: any) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);

    };

    const handleUploadFile = () => {
        if (file && fileName) {

            const formFileData = new FormData();
            formFileData.append('formFile', file);
            formFileData.append('fileName', fileName);
            formFileData.append('jobId', jobIdentifierFromUrl);


            setInProgress(true);

            checkingStatusCheckInterval();

            try {
                apiImportReceipts(formFileData);
            }
            catch (ex: any) {
                console.log(ex);
                //props.onError(ex);
            }
        }
    };


    return <>
        <PageContent>
            <>

                <TopBarWithBreadCrumb
                    contextLevel={props.contextLevel}
                    pageLevel="Receptury"
                />

                <h4>JobId: {jobIdentifierFromUrl}</h4>

                {(inProgress || jobData.done) &&
                    <div>
                        {inProgress && <Spinner loadingText={t('ReceiptsBeingImported')} />}
                        <div><b>{t('Status')}</b> {jobData.data.status}</div>
                        <div><b>{t('TotalReceipts')}</b> {jobData.data.totalReceipts}</div>
                        <div><b>{t('Errors')}</b> {jobData.data.failedReceipts}</div>
                        <div><b>{t('TimeOfLastStatusUpdate')}</b> {jobData.data.lastActivity}</div>
                        <div><br /><b>{t('History')}</b>{
                            jobData.data.history && jobData.data.history.length > 0 && jobData.data.history.map(h => {
                                return <div>{h}</div>;
                            })
                        }</div>
                    </div>
                }

                {!inProgress && !jobData.done && <div>
                    <div className="row" style={{ padding: '20px' }}>
                        <div className="col-12">
                            <div className={`card`}>
                                <div className="card-body">
                                    <label>{t('FileWithReceipts')}</label>
                                    <input type="file" style={{ width: '100%' }} onChange={handleFileChange}></input>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ padding: '20px', justifyContent: 'center' }}>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                            <button
                                style={{ width: '100%' }}
                                onClick={() => {
                                    //
                                }}
                                type="button"
                                className="btn-sm btn-warning"
                            >
                                {t('Cancel')}
                            </button>
                        </div>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                            <button
                                style={{ width: '100%' }}
                                onClick={() => {
                                    handleUploadFile();
                                }}
                                type="button"
                                className="btn-sm btn-primary"
                            >
                                {t('DoImport')}
                            </button>
                        </div>
                    </div>
                </div>}
            </>
        </PageContent>
    </>
}

export default ImportRecepturPage;